import React, { useState, useEffect } from 'react';
import BlogRecentPostTemplate from './BlogRecentPostTemplate';
import { fetchAllBlogPosts } from '../../Data/BlogPost';

function BlogRecentPosts() {
    const [recentPosts, setRecentPosts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchRecentPosts = async () => {
            try {
                setLoading(true);
                const posts = await fetchAllBlogPosts();
                
                if (posts && posts.length > 0) {
                    // Get the 3 most recent posts
                    const recent = posts.slice(0, 3);
                    setRecentPosts(recent);
                }
                setLoading(false);
            } catch (error) {
                console.error('Error fetching recent posts:', error);
                setLoading(false);
            }
        };

        fetchRecentPosts();
    }, []);

    if (loading) {
        return (
            <li className="widget widget_slope_recent_posts">
                <h2 className="widgettitle">Recent Activities</h2>
                <ul className="recent-posts">
                    <li>Loading...</li>
                </ul>
            </li>
        );
    }

    return (
        <li className="widget widget_slope_recent_posts">
            <h2 className="widgettitle">Recent Activities</h2>
            <ul className="recent-posts">
                {recentPosts.map((item, index) => {
                    return (
                        <BlogRecentPostTemplate
                            key={index}
                            image={item.image}
                            date={item.date}
                            designation={item.author}
                            title={item.title}
                            description={item.description}
                            slug={item.slug}
                        />
                    );
                })}
            </ul>
        </li>
    );
}

export default BlogRecentPosts;
